import React from 'react'
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg'
import './MapAllRemainingPanel.scss'

const MapAllRemainingPanel = ({ unmappedCount, onClick }) => {
    return (
        <div className="map-all-remaining-panel">
            <div className="map-all-remaining-panel__content">
                <div className="map-all-remaining-panel__icon">
                    <InfoIcon />
                </div>

                <div className="map-all-remaining-panel__text">
                    <h4 className="map-all-remaining-panel__title">Map all remaining variants in one click</h4>
                    <p className="map-all-remaining-panel__description">
                        We've detected <strong>{unmappedCount} variants</strong> remaining. Apply the same mapping to
                        these variants?
                    </p>
                </div>
            </div>
            <button className="map-all-remaining-panel__button" onClick={onClick}>
                Apply to remaining
            </button>
        </div>
    )
}

export default MapAllRemainingPanel
